import styled from '@emotion/styled';
import { Heading2, Heading3, Ui } from '@silvertours/front-shared';
import Image from 'next/image';

const Wrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-direction: column;
  align-items: center;
  max-width: 100%;

  ${({ theme }) => theme.mq('md')} {
    flex-direction: row;
    align-items: center;
  }

  ${({ theme }) => theme.mq('xl')} {
    flex-direction: row;
    align-items: center;
    max-width: 66.666%;
  }
`;

const ImageWrapper = styled.div`
  flex-shrink: 0;
`;

const StyledImage = styled(Image)`
  border-radius: 50%;
  width: 128px;
  height: 128px;
  object-fit: cover;
`;

const AuthorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.fontFamily.default};

  @media (max-width: 768px) {
    align-self: flex-start;
    width: 100%;
  }

  h2 {
    font-size: 1rem;
  }
`;

const AuthorTitle = styled(Heading2)`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-weight: 400;
  text-transform: uppercase;
`;

const AuthorName = styled(Heading3)`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
`;

const AuthorText = styled.p`
  margin: 0;
  font-size: 1.063rem;
  font-weight: 400;
  line-height: 1.588em;
`;

const WrapperSmall = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  height: 40px;
  margin-top: 10px;
`;

const ImageWrapperSmall = styled.div`
  flex-shrink: 0;
  height: 40px;
`;

const AuthorTextSmall = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: 1.063rem;
  font-weight: 400;
  line-height: 1.588em;
  height: 40px;
  display: inline;
  text-align: left;
`;

const StyledImageSmall = styled(Image)`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  object-fit: cover;
`;

const StyledLink = styled(Ui.TextLink)`
  white-space: nowrap;
`;

export {
  Wrapper,
  ImageWrapper,
  StyledImage,
  StyledImageSmall,
  AuthorWrapper,
  AuthorText,
  AuthorTitle,
  AuthorName,
  WrapperSmall,
  ImageWrapperSmall,
  StyledLink,
  AuthorTextSmall,
};
